import React from "react";
import SelectOne from "./SelectOne";
import SelectOneENPS from "./SelectOneENPS";
import { QuestionComponentType } from "./types";

const SelectENPS: QuestionComponentType = (props) => (
    <SelectOne {...props} CustomSelectComponent={SelectOneENPS} />
);

export default SelectENPS;
